import React, { useEffect, useState } from "react";
import "../styles/calendar.css";
import CalendarViews from "./calendar_views.js";
import YearReportPopUp from "./yearReport_popup.js";
import { secretKey, monthData } from "../.././data";
import Loading from "../helpers/loading_component.js";
import Swal from "sweetalert2";
import AddConfRoomRes from "./add_conf_room_res.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const ConfRoomRes = (props) => {
  const [monthName, setMonthName] = useState("");
  const [monthNameDisabled, setMonthNameDisabled] = useState("");
  const [weekName, setWeekName] = useState("");
  const [yearName, setYearName] = useState("");
  const [dayName, setDayName] = useState("");
  const [showReportPopUp, setShowReportPopUp] = useState(false);
  const [monthId, setMonthId] = useState("");
  const [dateC, setDateC] = useState(
    new Date(props.date).getFullYear() +
      "-" +
      (new Date(props.date).getMonth() < 10
        ? "0" + (new Date(props.date).getMonth() + 1)
        : new Date(props.date).getMonth() + 1) +
      "-" +
      (new Date(props.date).getDate() < 10
        ? "0" + new Date(props.date).getDate()
        : new Date(props.date).getDate())
  );
  const [expandFilters, setExpandFilters] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [hearings, setHearings] = useState([]);
  const [users, setUsers] = useState([]);
  const [subst, setSubst] = useState("");
  const [loading, setLoading] = useState(true);
  const [sellTasks, setSellTasks] = useState([]);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);
  const [confRoomRes, setConfRoomRes] = useState([]);
  const [showAddConfRoomRes, setShowAddConfRoomRes] = useState(false);
  const [showEditConfRoomRes, setShowEditConfRoomRes] = useState(false);
  const [confRoomResId, setConfRoomResId] = useState("");

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const showAddConfRoomResF = (e) => {
    setShowAddConfRoomRes(true);
  };

  const closeAddConfRoomResF = (e) => {
    setShowAddConfRoomRes(false);
    getData();
  };

  const showEditConfRoomResF = (e) => {
    var res = confRoomRes.filter((el) => +el.id === +e.currentTarget.value)[0];
    if (props.user.role !== "admin") {
      if (res.user !== props.user.name) {
        MySwal.fire({
          icon: "error",
          title: "Można",
          text: "edytować tylko własne rezerwacje sali",
        }).then((result) => {
          return;
        });
      } else {
        setShowEditConfRoomRes(true);
        setConfRoomResId(e.currentTarget.value);
      }
    } else {
      setShowEditConfRoomRes(true);
      setConfRoomResId(e.currentTarget.value);
    }
  };

  const closeEditConfRoomResF = (e) => {
    setShowEditConfRoomRes(false);
    setConfRoomResId("");
    getData();
  };

  const getMonthData = (monthNum) => {
    var data = props.monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const createMonthSet = () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var daysArray = [];
    var beginCounter = startMonthDate;
    while (beginCounter >= startMonthDate && beginCounter <= endMonthDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() + 1 < 10
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${
          beginCounter.getDate() < 10
            ? "0" + beginCounter.getDate()
            : beginCounter.getDate()
        }`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const createWeekSet = () => {
    var date = new Date(dateC);

    var dayStart = new Date(date).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;
    var startWeekDate = subDays(date, daysToSubStart);

    var weekArray = [];

    for (var i = 0; i <= 6; ++i) {
      var actualDate = addDays(startWeekDate, i);

      weekArray.push(
        `${actualDate.getFullYear()}-${
          actualDate.getMonth() + 1 < 10
            ? "0" + (actualDate.getMonth() + 1)
            : actualDate.getMonth() + 1
        }-${
          actualDate.getDate() < 10
            ? "0" + actualDate.getDate()
            : actualDate.getDate()
        }`
      );
    }

    return weekArray;
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchConfRoomRes();
      })
      .catch((error) => {});
  };

  const fetchConfRoomRes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getConfRoomRes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setConfRoomRes(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + weekNumber);
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
    fetchUsers();
  };

  useEffect(() => {
    getData();
  }, []);

  const getInitials = (user) => {
    var newData = users.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const createResButtonMonth = (res, date) => {
    var dateH = new Date(res.date_from);
    var dateR = new Date(date);

    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            key={res.id}
            id={"monthLinkTaskDone"}
            className="caseLink"
            value={res.id}
            onClick={showEditConfRoomResF}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {new Date(res.date_from).getHours() +
                  ":" +
                  (new Date(res.date_from).getMinutes() < 10
                    ? "0" + new Date(res.date_from).getMinutes()
                    : new Date(res.date_from).getMinutes()) +
                  " - " +
                  new Date(res.date_to).getHours() +
                  ":" +
                  (new Date(res.date_to).getMinutes() < 10
                    ? "0" + new Date(res.date_to).getMinutes()
                    : new Date(res.date_to).getMinutes()) +
                  " " +
                  getInitials(res.user)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const scrollBox = (e) => {
    const divToScrollTo = document.getElementById("cb" + e.target.value);
    divToScrollTo.scrollTo({
      top: divToScrollTo.scrollTop + 100,
      behavior: "smooth",
    });
  };

  const calendarMonthNew = (
    <>
      <div className="rowCalendar">
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          Poniedziałek
        </div>
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          Wtorek
        </div>
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          ŚRODA
        </div>
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          CZWARTEK
        </div>
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          PIĄTEK
        </div>
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          SOBOTA
        </div>
        <div
          className="cellCalendar"
          style={{
            height: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "900",
            backgroundColor: "white",
          }}
        >
          NIEDZIELA
        </div>
      </div>
      <div className="rowCalendar">
        {createMonthSet().map((el) => (
          <>
            <div key={el} className="cellCalendar">
              <div id={"cb" + new Date(el).getDate()} className="cellBox">
                <div id="mainCalendarBox">
                  {confRoomRes
                    .sort(function (a, b) {
                      return new Date(a.date_from) - new Date(b.date_from);
                    })
                    .map((el2) => (
                      <>{createResButtonMonth(el2, el)}</>
                    ))}
                </div>
              </div>

              <span className="cellDayNumber">
                {new Date(el).getFullYear() +
                  "-" +
                  (new Date(el).getMonth() < 10
                    ? "0" + (new Date(el).getMonth() + 1)
                    : new Date(el).getMonth() + 1) +
                  "-" +
                  (new Date(el).getDate() < 10
                    ? "0" + new Date(el).getDate()
                    : new Date(el).getDate())}
              </span>
            </div>
          </>
        ))}
      </div>
    </>
  );

  const goToMonthViewYear = (e) => {
    e.preventDefault();
    if (e.currentTarget.value === undefined) {
      return;
    }
    var year = new Date(dateC).getFullYear();
    var newDate = `${year}-${+e.currentTarget.value}-01`;
    props.setForYear(new Date(newDate));
  };
  const handleReportChange = (e) => {
    setShowReportPopUp(true);
    setMonthId(e.target.value);
  };

  const closeReport = (e) => {
    setShowReportPopUp(false);
    setMonthId("");
  };

  const handleCalendarUserChange = (e) => {
    props.setUserCalendar(e);
  };

  const handleResultFilterChange = (e) => {
    props.setResultFilter(e);
  };

  const handleCaseTypeFilterChange = (e) => {
    props.setCaseTypeFilter(e);
  };

  const handleCaseFormFilterChange = (e) => {
    props.setCaseFormFilter(e);
  };

  const handleCourtFilterChange = (e) => {
    props.setCourtFilter(e);
  };

  const handleTaskTypeFilterChange = (e) => {
    props.setTaskTypeFilter(e);
  };

  const handleExpandFiltersClick = (e) => {
    setExpandFilters(!expandFilters);
  };

  const clearFilters = (e) => {
    props.clearFilters();
    setExpandFilters(!expandFilters);
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    users.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const desktopFilters = (
    <>
      <div className="navigationCalendar">
        <>
          <div className="sectionTitleCalendar">
            {props.view === "month"
              ? monthName
              : props.view === "week"
              ? weekName
              : props.view === "year"
              ? yearName
              : props.view === "daily"
              ? dayName
              : ""}
          </div>
          <button
            className="navigationArrow"
            value="previous"
            onClick={props.setDate}
          >
            &#8592;
          </button>
          <button
            className="navigationArrow"
            value="next"
            onClick={props.setDate}
          >
            &#8594;
          </button>
        </>
      </div>
    </>
  );

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "1vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            value={props.user.name}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          <div className="navigationCalendar">
            <>
              <div className="navCalendar">
                <div className="sectionTitleCalendar">
                  {props.view === "month"
                    ? monthName
                    : props.view === "week"
                    ? weekName
                    : props.view === "year"
                    ? yearName
                    : props.view === "daily"
                    ? dayName
                    : ""}
                </div>
                <button
                  className="navigationArrow"
                  value="previous"
                  onClick={props.setDate}
                >
                  &#8592;
                </button>
                <button
                  className="navigationArrow"
                  value="next"
                  onClick={props.setDate}
                >
                  &#8594;
                </button>
              </div>
            </>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <>
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div
              className="paymentMenuContainer"
              style={{ padding: "2vw", paddingBottom: "0vw" }}
            >
              <>
                <button
                  style={{
                    backgroundColor: "#006d00",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  className="paymentMenuButton"
                  onClick={showAddConfRoomResF}
                >
                  Dodaj rezerwację sali
                </button>
              </>
            </div>
            <div className="desktopFilters" style={{ marginTop: "1vh" }}>
              {desktopFilters}
            </div>
            <div className="mobileFilters" style={{ marginTop: "1vh" }}>
              {mobileFilters}
            </div>
            {showAddConfRoomRes ? (
              <>
                <AddConfRoomRes
                  close={closeAddConfRoomResF}
                  users={props.users}
                  user={props.user}
                />{" "}
              </>
            ) : (
              ""
            )}
            {showEditConfRoomRes ? (
              <>
                <AddConfRoomRes
                  close={closeEditConfRoomResF}
                  confRoomRes={
                    confRoomRes.filter((el) => +el.id === +confRoomResId)[0]
                  }
                  mode={"edit"}
                  users={props.users}
                  user={props.user}
                />{" "}
              </>
            ) : (
              ""
            )}
            <div className="mainContainerCalendar">{calendarMonthNew}</div>
          </>
        )}
      </>
    </>
  );
};

export default ConfRoomRes;
